/* CIMINY - Avis clientes - YD Marketing & Data */
(function(){
var ICON={
'taille et coupe':'<rect x="2.5" y="8" width="19" height="8" rx="1"/><path d="M6 8v3M9.5 8v4.5M13 8v3M16.5 8v4.5"/>',
'matiere et qualite':'<rect x="6" y="3" width="12" height="3" rx="1"/><rect x="6" y="18" width="12" height="3" rx="1"/><path d="M8 6v12M16 6v12M8 9.5l8 2M8 13.5l8 2"/>',
'couleur':'<rect x="3.5" y="3.5" width="7" height="17" rx="3.5"/><path d="M10.5 8.5 14.6 4.4a1 1 0 0 1 1.4 0l3.6 3.6a1 1 0 0 1 0 1.4L10.5 18.5"/><circle cx="7" cy="16.5" r=".8"/>',
'livraison':'<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>',
'retours et echanges':'<path d="M4 9h11a5 5 0 0 1 0 10H9"/><path d="M8 5 4 9l4 4"/>',
'rapport qualite-prix':'<path d="M3.5 12.5 11.5 4.5h8v8l-8 8z"/><circle cx="15.5" cy="8.5" r="1.3"/>',
'style et morphologie':'<path d="M10 5.5a2 2 0 1 1 2 2v1.5"/><path d="M12 9 3.6 15.3c-.7.5-.3 1.7.5 1.7h15.8c.8 0 1.2-1.2.5-1.7z"/>',
'service client':'<path d="M20.5 12a8.5 8.5 0 0 1-12.3 7.6L3.5 21l1.4-4.5A8.5 8.5 0 1 1 20.5 12z"/>',
'entretien':'<path d="M3 7h18l-2 10.2a2 2 0 0 1-2 1.6H7a2 2 0 0 1-2-1.6z"/><path d="M3 7c2 1.6 4 1.6 6 0s4-1.6 6 0 4 1.6 6 0"/>'
};
var ICON_DEFAULT='<path d="M12 4v16M4 12h16"/>';
var STAR='M12 3.6l2.5 5.2 5.7.8-4.1 4 1 5.6L12 16.6l-5.1 2.6 1-5.6-4.1-4 5.7-.8z';
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;

function norm(s){return String(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim();}
function rnd(n){if(window.crypto&&crypto.getRandomValues){var a=new Uint32Array(1);crypto.getRandomValues(a);return a[0]%n;}return Math.floor(Math.random()*n);}
function shuffle(arr){var a=arr.slice();for(var i=a.length-1;i>0;i--){var j=rnd(i+1),t=a[i];a[i]=a[j];a[j]=t;}return a;}
function el(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt!=null)e.textContent=txt;return e;}
function svg(inner){var s=document.createElementNS('http://www.w3.org/2000/svg','svg');s.setAttribute('viewBox','0 0 24 24');s.setAttribute('aria-hidden','true');s.innerHTML=inner;return s;}
function stars(n){
  var w=el('span','av-stars');w.setAttribute('role','img');
  w.setAttribute('aria-label',String(Math.round(n*10)/10).replace('.',',')+' sur 5');
  for(var i=1;i<=5;i++){var s=svg('<path d="'+STAR+'"/>');if(i<=Math.round(n))s.setAttribute('class','on');w.appendChild(s);}
  return w;
}
function fmtDate(d){if(!d)return '';try{return new Intl.DateTimeFormat('fr-FR',{month:'long',year:'numeric'}).format(new Date(d+'T12:00:00'));}catch(e){return d;}}

/* Tirage : melange puis au plus 2 avis du meme theme au premier passage */
function draw(pool,n,exclude){
  var fresh=pool.filter(function(r){return exclude.indexOf(r)<0;});
  var src=shuffle(fresh);
  if(src.length<n)src=src.concat(shuffle(pool.filter(function(r){return exclude.indexOf(r)>-1;})));
  var out=[],per={},rest=[];
  src.forEach(function(r){var k=norm(r.k)||'_';if(out.length<n&&(per[k]||0)<2){out.push(r);per[k]=(per[k]||0)+1;}else rest.push(r);});
  for(var i=0;out.length<n&&i<rest.length;i++)out.push(rest[i]);
  return out;
}

function init(root){
  if(!root||root.dataset.avInit)return;
  root.dataset.avInit='1';
  var all=[];
  try{all=JSON.parse(root.querySelector('[data-av-data]').textContent)||[];}catch(e){all=[];}
  all=all.filter(function(r){return r&&r.t&&String(r.t).trim().length;});
  var source=root.dataset.source||'all',pid=root.dataset.pid||'';
  var isTrio=root.classList.contains('av-trio');
  var want=isTrio?3:Math.max(1,parseInt(root.dataset.count||'9',10));
  var topics=(root.dataset.themes||'').split(',').map(norm).filter(Boolean);

  var own=[],others=all.slice();
  if(pid&&source!=='all'){
    own=all.filter(function(r){return r.pid===pid;});
    others=all.filter(function(r){return r.pid!==pid;});
  }
  if(topics.length)others=others.filter(function(r){return topics.indexOf(norm(r.k))>-1;});
  if(source==='product_only')others=[];
  if(!own.length&&!others.length){root.hidden=true;return;}

  var shown=[];
  function pick(){
    var a=draw(own,want,shown);
    if(a.length<want)a=a.concat(draw(others,want-a.length,shown));
    shown=a;return a;
  }

  function card(r,i){
    var li=el('li','av-item');
    var c=el('article','av-card');c.style.setProperty('--av-d',(i%3)*70+'ms');
    var q=el('span','av-q','“');q.setAttribute('aria-hidden','true');c.appendChild(q);
    var top=el('div','av-top'),tp=el('span','av-topic');
    tp.appendChild(svg(ICON[norm(r.k)]||ICON_DEFAULT));
    tp.appendChild(document.createTextNode(r.k||'Avis cliente'));
    top.appendChild(tp);top.appendChild(stars(r.n||5));c.appendChild(top);
    if(r.h)c.appendChild(el('h3','av-h',r.h));
    c.appendChild(el('p','av-txt',r.t));
    var more=el('button','av-more','Lire la suite');more.type='button';more.hidden=true;
    more.setAttribute('aria-expanded','false');
    more.addEventListener('click',function(){
      var o=c.classList.toggle('open');
      more.setAttribute('aria-expanded',o?'true':'false');
      more.textContent=o?'Réduire':'Lire la suite';
    });
    c.appendChild(more);
    var chips=el('div','av-chips'),has=false;
    if(r.fit){chips.appendChild(el('span','av-chip av-chip--fit',r.fit));has=true;}
    var m=[];
    if(r.hh)m.push(r.hh);
    if(r.th)m.push('habituellement '+r.th);
    if(r.tc)m.push('a pris '+r.tc);
    if(m.length){chips.appendChild(el('span','av-chip',m.join(' · ')));has=true;}
    if(has)c.appendChild(chips);
    c.appendChild(el('div','av-spacer'));
    var foot=el('div','av-foot');
    var who=r.a&&r.a.trim()?r.a.trim():'Cliente CIMINY';
    var mono=el('span','av-mono',who.charAt(0).toUpperCase());mono.setAttribute('aria-hidden','true');
    foot.appendChild(mono);
    var w=el('div','av-who'),nm=el('div','av-name',who);
    if(r.v){var vf=el('span','av-verif');vf.appendChild(svg('<path d="M5 12.5 10 17 19 7"/>'));vf.appendChild(document.createTextNode('Achat vérifié'));nm.appendChild(vf);}
    w.appendChild(nm);
    var sub=el('div','av-sub'),dt=fmtDate(r.d);
    if(r.pt&&r.pu&&r.pid!==pid){
      var a=el('a',null,r.pt);a.href=r.pu;
      sub.appendChild(document.createTextNode('Sur '));sub.appendChild(a);
      if(dt)sub.appendChild(document.createTextNode(' · '+dt));
    }else if(dt){sub.textContent=dt;}
    if(sub.childNodes.length)w.appendChild(sub);
    foot.appendChild(w);c.appendChild(foot);li.appendChild(c);
    return li;
  }

  function summary(){
    var box=root.querySelector('[data-av-sum]');if(!box)return;
    var base=own.length?own:all;
    if(base.length<2){box.hidden=true;return;}
    var sum=0;base.forEach(function(r){sum+=Number(r.n)||0;});
    var avg=sum/base.length;
    root.querySelector('[data-av-avg]').textContent=avg.toFixed(1).replace('.',',');
    var st=root.querySelector('[data-av-sum-stars]');st.innerHTML='';st.appendChild(stars(avg));
    root.querySelector('[data-av-sum-txt]').textContent=(own.length?'Moyenne sur ':'Moyenne sur l’ensemble de nos ')+base.length+' avis';
    var fits=base.filter(function(r){return r.fit;}),fbox=root.querySelector('[data-av-fit]');
    if(fbox&&fits.length>=parseInt(root.dataset.minFit||'3',10)){
      var score=0,juste=0;
      fits.forEach(function(r){var f=norm(r.fit);if(f.indexOf('petit')>-1)score-=1;else if(f.indexOf('grand')>-1)score+=1;else juste++;});
      root.querySelector('[data-av-fit-val]').textContent='Taille juste pour '+Math.round(juste/fits.length*100)+' % d’entre elles';
      root.querySelector('[data-av-fit-dot]').style.setProperty('--av-pos',(50+score/fits.length*50)+'%');
      fbox.hidden=false;
    }
    box.hidden=false;
  }

  var rail=root.querySelector('.av-rail');
  var prev=root.querySelector('[data-av-prev]'),next=root.querySelector('[data-av-next]');
  var bar=root.querySelector('[data-av-bar]'),cur=root.querySelector('[data-av-cur]'),tot=root.querySelector('[data-av-tot]');
  var io=('IntersectionObserver' in window&&!reduce)?new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:.15}):null;
  function pad(n){return(n<10?'0':'')+n;}
  function step(){var it=rail.querySelector('.av-item');if(!it)return 300;return it.getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0);}
  var ticking=false;
  function update(){
    ticking=false;
    var n=rail.querySelectorAll('.av-item').length;
    if(tot)tot.textContent=pad(n);
    var max=rail.scrollWidth-rail.clientWidth,x=rail.scrollLeft;
    if(prev)prev.disabled=x<=1;
    if(next)next.disabled=max<=1||x>=max-1;
    if(bar)bar.style.transform='scaleX('+(max<=1?1:Math.min(1,Math.max(0,x/max)))+')';
    if(cur)cur.textContent=pad(Math.min(n,Math.round(x/step())+1));
  }
  function render(){
    var list=pick();
    rail.innerHTML='';
    list.forEach(function(r,i){rail.appendChild(card(r,i));});
    rail.scrollLeft=0;
    requestAnimationFrame(function(){
      rail.querySelectorAll('.av-card').forEach(function(c){
        var t=c.querySelector('.av-txt'),mo=c.querySelector('.av-more');
        if(t&&mo&&t.scrollHeight>t.clientHeight+2)mo.hidden=false;
        if(io)io.observe(c);else c.classList.add('in');
      });
      update();
    });
  }
  rail.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});
  window.addEventListener('resize',update,{passive:true});
  if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:reduce?'auto':'smooth'});});
  if(next)next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:reduce?'auto':'smooth'});});
  var sh=root.querySelector('[data-av-shuffle]');
  if(sh){if(own.length+others.length<=want)sh.hidden=true;sh.addEventListener('click',render);}
  summary();render();
}

function boot(){document.querySelectorAll('.cav[data-cav]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.cav[data-cav]');if(r)init(r);});
})();